/* DijiStream LIVE review engine.
 *
 * Fetches reviews straight from Judge.me's own public widget endpoint
 * (api.judge.me/reviews/reviews_for_widget) — the same data Judge.me's widget uses.
 *   • No private token (public endpoint; CORS-allowed for the storefront origin)
 *   • No server / no worker
 *   • No static snapshot — reviews are ALWAYS live; new reviews appear automatically
 *   • Lazy: fetched only when the reviews section nears the viewport, 30 at a time, then cached
 *
 * We parse Judge.me's returned HTML, then render it in OUR own card markup under OUR rules.
 * Config comes from window.__DIJI_REVIEWS_CFG__ ({shop, productId}) set per-request in theme.liquid.
 * Labels come from window.__DIJI_REVIEWS_I18N__ (localized via {{ 't' }}).
 * Exposes window.DijiReviews = { load, filter, quoteCard, prwItem, whenVisible, fmtDate }.
 */
(function () {
  if (window.DijiReviews) return;

  var STAR_ON = '<svg viewBox="0 0 24 24" width="24" height="24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
  var STAR_OFF = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>';

  var API = 'https://api.judge.me/reviews/reviews_for_widget';
  var PER_FETCH = 30; // Judge.me caps per_page at 30

  function cfg() { return window.__DIJI_REVIEWS_CFG__ || {}; }
  function L(key, fb) { var m = window.__DIJI_REVIEWS_I18N__ || {}; return m[key] || fb; }
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function initials(name) {
    var w = (name || '').trim().split(/\s+/).slice(0, 2);
    return w.map(function (x) { return (x[0] || '').toUpperCase(); }).join('') || '?';
  }
  function fmtDate(d) {
    if (!d) return '';
    try {
      /* Judge.me returns "2026-06-02 09:25:00 UTC" — normalise to ISO for Date(). */
      var iso = String(d).replace(' UTC', 'Z').replace(' ', 'T');
      var lang = document.documentElement.lang || 'en';
      var dt = new Date(iso);
      if (isNaN(dt.getTime())) return '';
      return dt.toLocaleDateString(lang, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (e) { return ''; }
  }
  function starRow(n, withEmpty) {
    n = Math.max(0, Math.min(5, Math.round(n || 0)));
    var h = '';
    for (var i = 0; i < n; i++) h += STAR_ON;
    if (withEmpty) for (var e = 0; e < 5 - n; e++) h += STAR_OFF;
    return h;
  }

  /* ── Run cb when el nears the viewport (lazy fetch). Falls back to immediate if no IO. ── */
  function whenVisible(el, cb) {
    if (!el || !('IntersectionObserver' in window)) return cb();
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { io.disconnect(); cb(); return; }
      }
    }, { rootMargin: '500px 0px' });
    io.observe(el);
  }

  /* ── Run cb only AFTER window 'load' AND the browser is idle, so the review HTTP never
     competes with initial paint / critical resources. Falls back to a short timeout. ── */
  function afterLoadIdle(cb) {
    function idle() {
      if ('requestIdleCallback' in window) { requestIdleCallback(cb, { timeout: 3000 }); }
      else { setTimeout(cb, 200); }
    }
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  }

  /* ── Parse one Judge.me .jdgm-rev chunk into our review object (incl. photos + videos). ── */
  function parseChunk(el) {
    var ratingEl = el.querySelector('.jdgm-rev__rating');
    var rating = ratingEl ? (parseInt(ratingEl.getAttribute('data-score'), 10) || 0) : 0;
    var tsEl = el.querySelector('.jdgm-rev__timestamp');
    var pics = [], media = [];
    var links = el.querySelectorAll('.jdgm-rev__pic-link');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], img = a.querySelector('img');
      var thumb = img ? (img.getAttribute('data-src') || img.getAttribute('src') || '') : '';
      var href = a.getAttribute('href') || thumb;
      var dv = a.getAttribute('data-video-url');
      var isVid = dv || /video/i.test(a.className || '') || /\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(href || '');
      if (isVid) { media.push({ type: 'video', url: dv || href, thumb: thumb }); }
      else if (href) { pics.push(href); media.push({ type: 'image', url: href, thumb: thumb || href }); }
    }
    if (!links.length) {
      var imgs = el.querySelectorAll('.jdgm-rev__pics img, .jdgm-rev__pic img');
      for (var k = 0; k < imgs.length; k++) {
        var u = imgs[k].getAttribute('data-src') || imgs[k].getAttribute('src');
        if (u) { pics.push(u); media.push({ type: 'image', url: u, thumb: u }); }
      }
    }
    return {
      r: rating,
      t: ((el.querySelector('.jdgm-rev__title') || {}).textContent || '').trim(),
      b: ((el.querySelector('.jdgm-rev__body') || {}).textContent || '').trim(),
      n: ((el.querySelector('.jdgm-rev__author') || {}).textContent || '').trim() || 'Anonymous',
      d: tsEl ? (tsEl.getAttribute('data-content') || '') : '',
      v: el.getAttribute('data-verified-buyer') === 'true',
      pics: pics,
      media: media,
      pt: '' /* product title; filled per-surface when known */
    };
  }

  /* ── Fetch one page (30) from Judge.me. Returns {reviews:[], total}. ── */
  function fetchPage(productId, page) {
    var c = cfg();
    var u = API + '?url=' + encodeURIComponent(c.shop) + '&shop_domain=' + encodeURIComponent(c.shop) +
      '&platform=shopify&page=' + page + '&per_page=' + PER_FETCH + '&product_id=' + encodeURIComponent(productId);
    return fetch(u, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (j) {
      var doc = new DOMParser().parseFromString(j.html || '', 'text/html');
      var nodes = doc.querySelectorAll('.jdgm-rev');
      var revs = [];
      for (var i = 0; i < nodes.length; i++) revs.push(parseChunk(nodes[i]));
      return { reviews: revs, total: parseInt(j.total_count, 10) || revs.length };
    });
  }

  /* ── Fetch every review for a product: page 1 (reveals total), then the rest in parallel. ── */
  function fetchAll(productId) {
    return fetchPage(productId, 1).then(function (first) {
      var total = first.total;
      var reviews = first.reviews.slice();
      var pages = Math.ceil(total / PER_FETCH);
      var rest = [];
      for (var p = 2; p <= pages; p++) rest.push(fetchPage(productId, p));
      return Promise.all(rest).then(function (results) {
        for (var i = 0; i < results.length; i++) reviews = reviews.concat(results[i].reviews);
        return { reviews: reviews, total: total };
      });
    });
  }

  var CACHE = {};
  /* ── load(cb, productId): fetch (or reuse cached) all reviews for the product. cb(null) on failure. ── */
  function load(cb, productId) {
    var c = cfg();
    productId = productId || c.productId;
    if (!productId || !c.shop) { return cb(null); }
    if (CACHE[productId]) { return cb(CACHE[productId]); }
    fetchAll(productId).then(function (res) {
      var pt = c.productTitle || '', pu = c.productUrl || '', pi = c.productImage || '';
      for (var i = 0; i < res.reviews.length; i++) { var rr = res.reviews[i]; rr.pid = String(productId); rr.shop = false; rr.pt = pt; rr.pturl = pu; rr.ptimg = pi; }
      var data = { count: res.total, reviews: res.reviews };
      CACHE[productId] = data;
      cb(data);
    }).catch(function () { cb(null); });
  }

  /* ── Filter + sort. opts: {source, productId, minStars, minLength, requirePics, max}.
     Applies BOTH section-level filters (opts.*) AND the general per-star % filter from theme
     settings (window.__DIJI_REVIEWS_FILTERS__ = {5:pct,…,1:pct}). The per-star math mirrors
     dynamic-reviews-stats.liquid exactly so the rendered list + pagination match the shown count. ── */
  function filter(data, opts) {
    opts = opts || {};
    var src = opts.source || 'product';
    var out = ((data && data.reviews) || []).filter(function (r) {
      if (src === 'product' && r.shop) return false;
      if (src === 'store' && !r.shop) return false;
      if (opts.productId && String(r.pid) !== String(opts.productId)) return false;
      if (opts.minStars && (r.r || 0) < opts.minStars) return false;
      if (opts.minLength && (r.b || '').length < opts.minLength) return false;
      if (opts.requirePics && !(r.pics && r.pics.length)) return false;
      return true;
    });
    var F = window.__DIJI_REVIEWS_FILTERS__;
    if (F) {
      out.sort(function (a, b) { return String(b.d || '').localeCompare(String(a.d || '')); });
      var byStar = { 1: [], 2: [], 3: [], 4: [], 5: [] };
      out.forEach(function (r) { byStar[Math.max(1, Math.min(5, Math.round(r.r || 0)))].push(r); });
      var kept = [];
      for (var s = 1; s <= 5; s++) {
        var arr = byStar[s], pct = (F[s] == null ? 100 : F[s]);
        if (pct > 0 && arr.length) {
          var keepN = Math.round(arr.length * pct / 100);
          kept = kept.concat(arr.slice(0, keepN < 1 ? 1 : keepN));
        }
      }
      out = kept;
    }
    out.sort(function (a, b) {
      var f = (b.f ? 1 : 0) - (a.f ? 1 : 0);
      if (f) return f;
      return String(b.d || '').localeCompare(String(a.d || ''));
    });
    if (opts.max && opts.max > 0) out = out.slice(0, opts.max);
    return out;
  }

  /* .rv-quote card — matches section__featured-reviews.liquid markup. */
  function quoteCard(r, opts) {
    opts = opts || {};
    var tier = opts.tier ? ' tier--' + opts.tier : '';
    var text = r.b || r.t || '';
    var pics = r.pics || [];
    var picHtml = '';
    if (pics.length) {
      var inner = '';
      var ph = esc(L('photo', 'Review photo'));
      for (var i = 0; i < pics.length; i++) {
        var extra = (i === 1 && pics.length > 2) ? ' data-pic-extra="' + (pics.length - 2) + '"' : '';
        inner += '<button type="button" class="fr-rev__pic" data-fr-pic data-pic-full="' + esc(pics[i]) + '"' + extra + ' aria-label="' + ph + '"><img src="' + esc(pics[i]) + '" alt="' + ph + '" loading="lazy" width="120" height="120"></button>';
      }
      picHtml = '<div class="fr-rev__pics" data-pic-count="' + pics.length + '">' + inner + '</div>';
    }
    var bodyHtml = (text || pics.length)
      ? '<div class="rv-quote__body' + (pics.length ? ' rv-quote__body--with-pics' : '') + '">' + (text ? '<p class="rv-quote__text">' + esc(text) + '</p>' : '') + picHtml + '</div>'
      : '';
    var dateHtml = r.d ? '<span class="rv-quote__location">' + esc(fmtDate(r.d)) + '</span>' : '';
    /* Verified badge always shown — matches the server-rendered card so the live swap is seamless. */
    var verHtml = '<span class="rv-quote__verified">' + CHECK + esc(L('verified', 'Verified')) + '</span>';
    var prodHtml = r.pt
      ? '<a class="fr-rev__product" href="' + esc(r.pturl || '#') + '">' + (r.ptimg ? '<img src="' + esc(r.ptimg) + '" alt="' + esc(r.pt) + '" loading="lazy" width="40" height="40">' : '') + '<span class="fr-rev__product-text"><span class="fr-rev__product-label">' + esc(L('review_for', 'Review for')) + '</span><span class="fr-rev__product-title">' + esc(r.pt) + '</span></span></a>'
      : '';
    return '<div class="rv-quote' + tier + ' rv-reveal in-view">'
      + '<div class="rv-quote__header"><div class="rv-quote__avatar">' + esc(initials(r.n)) + '</div>'
      + '<div class="rv-quote__byline"><span class="rv-quote__name">' + esc(r.n) + '</span>' + dateHtml + '</div>' + verHtml + '</div>'
      + '<div class="rv-quote__main"><div class="rv-quote__stars">' + starRow(r.r, false) + '</div>' + bodyHtml + '</div>'
      + prodHtml
      + '</div>';
  }

  /* .prw__item card — matches product-reviews-widget.liquid markup. */
  function prwItem(r, opts) {
    opts = opts || {};
    var photos = (r.pics || []).length;
    var title = r.t ? '<h4 class="prw__rev-title">' + esc(r.t) + '</h4>' : '';
    var body = r.b ? '<p class="prw__body">' + esc(r.b) + '</p>' : '';
    var picsHtml = '';
    if (photos) {
      var inner = '';
      var ph2 = esc(L('photo', 'Review photo'));
      for (var i = 0; i < r.pics.length; i++) {
        inner += '<button type="button" class="prw__pic" data-prw-pic data-pic-full="' + esc(r.pics[i]) + '" aria-label="' + ph2 + '"><img src="' + esc(r.pics[i]) + '" alt="' + ph2 + '" loading="lazy" width="120" height="120"></button>';
      }
      picsHtml = '<div class="prw__carousel" data-prw-carousel data-pic-count="' + photos + '"><button type="button" class="prw__carousel-nav prw__carousel-nav--prev" data-prw-carousel-prev aria-label="" hidden>‹</button><div class="prw__pics" data-prw-pics>' + inner + '</div><button type="button" class="prw__carousel-nav prw__carousel-nav--next" data-prw-carousel-next aria-label="" hidden>›</button></div>';
    }
    var sc = Math.max(0, Math.min(5, Math.round(r.r || 0)));
    var vlabel = esc(L('verified', 'Verified'));
    var ver = '<span class="prw__verified" title="' + vlabel + '">' + CHECK + vlabel + '</span>';
    var date = r.d ? '<span class="prw__date">' + esc(fmtDate(r.d)) + '</span>' : '';
    return '<article class="prw__item" data-prw-item data-prw-score="' + sc + '" data-prw-photos="' + photos + '" data-prw-has-photos="' + (photos > 0 ? 1 : 0) + '" data-prw-date="' + esc(r.d || '') + '">'
      + '<header class="prw__item-header"><div class="prw__avatar" aria-hidden="true">' + esc(initials(r.n)) + '</div><div class="prw__byline"><span class="prw__author">' + esc(r.n) + '</span>' + date + '</div>' + ver + '</header>'
      + '<div class="prw__stars" aria-label="' + sc + ' out of 5 stars">' + starRow(sc, true) + '</div>' + title + body + picsHtml
      + '</article>';
  }

  /* ───────────────────────── Media gallery + synced lightbox ───────────────────────── */
  var _cssDone = false;
  function ensureMediaCSS() {
    if (_cssDone) return; _cssDone = true;
    var css =
      '.dj-mediagal{margin:0 0 1.25rem;}' +
      '.dj-mediagal__strip{display:flex;gap:8px;overflow-x:auto;padding:2px 2px 10px;scroll-snap-type:x proximity;-webkit-overflow-scrolling:touch;}' +
      '.dj-mediagal__strip::-webkit-scrollbar{height:6px;}.dj-mediagal__strip::-webkit-scrollbar-thumb{background:rgba(14,42,71,.25);border-radius:3px;}' +
      '.dj-mediagal__item{flex:0 0 auto;width:92px;height:92px;border-radius:10px;overflow:hidden;position:relative;cursor:pointer;border:1px solid rgba(14,42,71,.12);padding:0;background:#e8eef5;scroll-snap-align:start;}' +
      '.dj-mediagal__item img{width:100%;height:100%;object-fit:cover;display:block;}' +
      '.dj-mediagal__play{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;font-size:24px;background:rgba(0,0,0,.32);}' +
      '.dj-lbx{position:fixed;inset:0;z-index:100000;background:rgba(6,16,28,.88);display:flex;align-items:center;justify-content:center;}' +
      '.dj-lbx[hidden]{display:none;}' +
      '.dj-lbx__panel{display:flex;width:min(1080px,94vw);max-height:90vh;background:#fff;border-radius:14px;overflow:hidden;box-shadow:0 24px 80px rgba(0,0,0,.5);}' +
      '.dj-lbx__media{flex:1 1 58%;background:#06101c;display:flex;align-items:center;justify-content:center;min-height:320px;}' +
      '.dj-lbx__media img,.dj-lbx__media video{max-width:100%;max-height:90vh;object-fit:contain;display:block;}' +
      '.dj-lbx__detail{flex:1 1 42%;padding:1.6rem;overflow-y:auto;color:#0E2A47;text-align:start;}' +
      '.dj-lbx__head{display:flex;align-items:center;gap:.7rem;margin-bottom:.8rem;}' +
      '.dj-lbx__avatar{width:38px;height:38px;border-radius:50%;background:#D4E6F7;color:#0E2A47;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:.8rem;flex-shrink:0;}' +
      '.dj-lbx__name{font-weight:700;}.dj-lbx__date{font-size:.8rem;opacity:.7;}' +
      '.dj-lbx__verified{margin-left:auto;display:inline-flex;align-items:center;gap:3px;font-size:.75rem;color:#1CA0E8;}.dj-lbx__verified svg{width:15px;height:15px;}' +
      '.dj-lbx__stars{display:flex;gap:2px;color:#1CA0E8;margin-bottom:.6rem;}.dj-lbx__stars svg{width:18px;height:18px;}' +
      '.dj-lbx__title{margin:.2rem 0 .4rem;font-size:1.05rem;}.dj-lbx__body{line-height:1.55;margin:0 0 1rem;}' +
      '.dj-lbx__product{font-size:.82rem;opacity:.7;border-top:1px solid rgba(14,42,71,.12);padding-top:.7rem;}' +
      '.dj-lbx__nav{position:fixed;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.92);border:0;width:46px;height:46px;border-radius:50%;cursor:pointer;font-size:24px;color:#0E2A47;display:flex;align-items:center;justify-content:center;}' +
      '.dj-lbx__nav--prev{left:18px;}.dj-lbx__nav--next{right:18px;}' +
      '.dj-lbx__close{position:fixed;top:18px;right:18px;background:rgba(255,255,255,.92);border:0;width:42px;height:42px;border-radius:50%;cursor:pointer;font-size:24px;color:#0E2A47;z-index:1;}' +
      '.dj-lbx__counter{position:fixed;bottom:20px;left:50%;transform:translateX(-50%);color:#fff;font-size:.85rem;background:rgba(0,0,0,.4);padding:4px 12px;border-radius:20px;}' +
      'html[data-theme="dark"] .dj-lbx__panel{background:#0E2A47;}html[data-theme="dark"] .dj-lbx__detail{color:#EAF2FB;}html[data-theme="dark"] .dj-lbx__product{border-top-color:rgba(255,255,255,.14);}' +
      '@media(max-width:768px){.dj-lbx__panel{flex-direction:column;max-height:94vh;}.dj-lbx__media{flex:0 0 auto;max-height:48vh;min-height:200px;}.dj-lbx__nav{top:auto;bottom:74px;transform:none;}}';
    var st = document.createElement('style'); st.id = 'dj-reviews-media-css'; st.textContent = css;
    document.head.appendChild(st);
  }

  /* Flatten a reviews ARRAY's media into [{type,url,thumb,review}]. */
  function mediaFromReviews(reviews) {
    var out = [];
    for (var i = 0; i < (reviews || []).length; i++) {
      var r = reviews[i], m = r.media || [];
      for (var j = 0; j < m.length; j++) out.push({ type: m[j].type, url: m[j].url, thumb: m[j].thumb, review: r });
    }
    return out;
  }
  /* Flatten all (filtered) reviews' media — convenience over filter(). */
  function mediaItems(data, opts) { return mediaFromReviews(filter(data, opts || {})); }

  var _lb = null, _lbItems = [], _lbIdx = 0;
  function lbRender() {
    var it = _lbItems[_lbIdx]; if (!it) return;
    var r = it.review || {};
    var mediaEl = _lb.querySelector('[data-dj-lbx-media]');
    mediaEl.innerHTML = (it.type === 'video')
      ? '<video src="' + esc(it.url) + '" controls autoplay playsinline poster="' + esc(it.thumb || '') + '"></video>'
      : '<img src="' + esc(it.url) + '" alt="' + esc(L('photo', 'Review photo')) + '">';
    var ver = r.v ? '<span class="dj-lbx__verified">' + CHECK + esc(L('verified', 'Verified')) + '</span>' : '';
    var date = r.d ? '<span class="dj-lbx__date">' + esc(fmtDate(r.d)) + '</span>' : '';
    var prod = r.pt ? '<div class="dj-lbx__product">' + esc(L('review_for', 'Review for')) + ' ' + esc(r.pt) + '</div>' : '';
    _lb.querySelector('[data-dj-lbx-detail]').innerHTML =
      '<div class="dj-lbx__head"><div class="dj-lbx__avatar">' + esc(initials(r.n)) + '</div>' +
      '<div><div class="dj-lbx__name">' + esc(r.n) + '</div>' + date + '</div>' + ver + '</div>' +
      '<div class="dj-lbx__stars">' + starRow(r.r, true) + '</div>' +
      (r.t ? '<h4 class="dj-lbx__title">' + esc(r.t) + '</h4>' : '') +
      (r.b ? '<p class="dj-lbx__body">' + esc(r.b) + '</p>' : '') + prod;
    _lb.querySelector('[data-dj-lbx-counter]').textContent = (_lbIdx + 1) + ' / ' + _lbItems.length;
  }
  function lbGo(d) { _lbIdx = (_lbIdx + d + _lbItems.length) % _lbItems.length; lbRender(); }
  function closeLightbox() { if (!_lb) return; _lb.setAttribute('hidden', ''); var v = _lb.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} } document.documentElement.style.overflow = ''; }
  function openLightbox(items, idx) {
    if (!items || !items.length) return;
    ensureMediaCSS();
    if (!_lb) {
      _lb = document.createElement('div'); _lb.className = 'dj-lbx'; _lb.setAttribute('hidden', '');
      _lb.innerHTML =
        '<button class="dj-lbx__close" data-dj-lbx-close aria-label="Close">×</button>' +
        '<button class="dj-lbx__nav dj-lbx__nav--prev" data-dj-lbx-prev aria-label="Previous">‹</button>' +
        '<div class="dj-lbx__panel"><div class="dj-lbx__media" data-dj-lbx-media></div><div class="dj-lbx__detail" data-dj-lbx-detail></div></div>' +
        '<button class="dj-lbx__nav dj-lbx__nav--next" data-dj-lbx-next aria-label="Next">›</button>' +
        '<div class="dj-lbx__counter" data-dj-lbx-counter></div>';
      document.body.appendChild(_lb);
      _lb.addEventListener('click', function (e) {
        if (e.target === _lb || e.target.closest('[data-dj-lbx-close]')) return closeLightbox();
        if (e.target.closest('[data-dj-lbx-prev]')) return lbGo(-1);
        if (e.target.closest('[data-dj-lbx-next]')) return lbGo(1);
      });
      document.addEventListener('keydown', function (e) {
        if (_lb.hasAttribute('hidden')) return;
        if (e.key === 'Escape') closeLightbox(); else if (e.key === 'ArrowLeft') lbGo(-1); else if (e.key === 'ArrowRight') lbGo(1);
      });
      var x0 = null;
      _lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      _lb.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) lbGo(dx < 0 ? 1 : -1); x0 = null; });
    }
    _lbItems = items; _lbIdx = idx || 0; lbRender();
    _lb.removeAttribute('hidden'); document.documentElement.style.overflow = 'hidden';
  }

  /* Render the media strip into a container (self-hides when there's no media). */
  /* Render the media strip from a reviews ARRAY (so it can follow the active filters).
     Items are stored on the container so the (once-bound) click handler always opens the
     CURRENT set; self-hides when the filtered set has no media. */
  function mediaGallery(container, reviews) {
    if (!container) return;
    var items = mediaFromReviews(reviews);
    container.__djItems = items;
    if (!items.length) { container.style.display = 'none'; container.innerHTML = ''; return; }
    ensureMediaCSS();
    var html = '<div class="dj-mediagal__strip" role="list">';
    for (var i = 0; i < items.length; i++) {
      var m = items[i];
      html += '<button type="button" class="dj-mediagal__item" data-dj-media="' + i + '" aria-label="' + esc(L('photo', 'Review photo')) + '">';
      if (m.type === 'video') html += '<span class="dj-mediagal__play" aria-hidden="true">▶</span>';
      html += '<img src="' + esc(m.thumb || m.url) + '" loading="lazy" alt="">';
      html += '</button>';
    }
    html += '</div>';
    container.innerHTML = html; container.style.display = '';
    if (!container.__djBound) {
      container.__djBound = true;
      container.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dj-media]'); if (!b) return;
        openLightbox(container.__djItems, parseInt(b.getAttribute('data-dj-media'), 10) || 0);
      });
    }
  }

  window.DijiReviews = { load: load, filter: filter, quoteCard: quoteCard, prwItem: prwItem, whenVisible: whenVisible, afterLoadIdle: afterLoadIdle, fmtDate: fmtDate, mediaGallery: mediaGallery, mediaItems: mediaItems, mediaFromReviews: mediaFromReviews, openLightbox: openLightbox };
  window.__DIJI_REVIEWS_SOURCE__ = 'LIVE: ' + API + ' (Judge.me public widget endpoint — no token, no static file)';

  /* Ready-queue: sections register before this deferred engine runs; drain once, then fire immediately. */
  var _pending = window.__DIJI_REVIEWS_READY__;
  window.__DIJI_REVIEWS_READY__ = { push: function (cb) { try { cb(window.DijiReviews); } catch (e) {} } };
  if (_pending && _pending.length) {
    _pending.forEach(function (cb) { try { cb(window.DijiReviews); } catch (e) {} });
  }
})();
